import * as React from 'react'

import { css, FontWeight, styled } from '../theme'
import { Color, ColorInText, colors } from '../theme/colors'
import {
  HorizontalMarginProps,
  horizontalMarginsCss,
  VerticalMarginProps,
  verticalMarginsCss,
} from '../theme/css'
import { TextFontWeight as FontWeightInText } from '../theme/font'

enum FontSize {
  xxxs = 'xxxs',
  xxs = 'xxs',
  xs = 'xs',
  s = 's',
  m = 'm',
  l = 'l',
  xl = 'xl',
  xxl = 'xxl',

  xxsBold = 'xxsBold',
  xsBold = 'xsBold',
  sBold = 'sBold',
  mBold = 'mBold',
  lBold = 'lBold',
  xlBold = 'xlBold',
  xxlBold = 'xxlBold',
}

type FontSizeInText =
  | 'xxxs'
  | 'xxs'
  | 'xs'
  | 's'
  | 'm'
  | 'l'
  | 'xl'
  | 'xxl'
  | 'xxsBold'
  | 'xsBold'
  | 'sBold'
  | 'mBold'
  | 'lBold'
  | 'xlBold'
  | 'xxlBold'

export interface Props {
  as?: 'div' | 'li' | 'span' | 'p'
  className?: string
  size?: FontSize | FontSizeInText
  weight?: FontWeight | FontWeightInText
  uppercase?: boolean
  color?: Color | ColorInText
  ellipsis?: boolean
  underline?: boolean
  children?: React.ReactNode
}

const TextRaw: React.FunctionComponent<
  Props & HorizontalMarginProps & VerticalMarginProps
> = ({ as: As = 'span', className, children }) => {
  //TODO tipar lo siguiente adecuadamente
  const Tag = As as any
  return <Tag className={className}>{children}</Tag>
}

const Text = styled(TextRaw)`
  ${horizontalMarginsCss}
  ${verticalMarginsCss}
  
  ${p => p.uppercase && `text-transform: uppercase;`};
  ${p =>
    p.size ? p.theme.font[p.size](p.weight) : p.theme.font.base(p.weight)};

  color: ${p => p.color && colors[p.color]};
  opacity: 1;

  ${p =>
    p.underline &&
    css`
      text-decoration: underline;
    `}

  ${p =>
    p.ellipsis &&
    css`
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
`
export default Text
